export default "__VITE_ASSET__MOkgM6Wp__"